import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentythirdtheme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Bronze */
            --bronze-dark: #451a03; 
            --bronze: #b45309; 
            --gold: #f59e0b;
            --bg-dark: #1c1917;
            --bg-card: #292524;
            --text-main: #e7e5e4;
        }

        body { background-color: var(--bg-dark); color: var(--text-main); font-family: 'Cinzel', serif; margin: 0; }
        h1, h2, h3 { font-weight: 400; letter-spacing: 2px; text-transform: uppercase; color: var(--gold); }
        .container { max-width: 1100px; margin: 0 auto; padding: 0 40px; }
        
        .nav { border-bottom: 1px solid var(--bronze); padding: 30px 0; display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 2rem; color: var(--bronze); }
        .links a { color: var(--text-main); margin-left: 30px; text-decoration: none; font-size: 0.9rem; letter-spacing: 1px; }
        .links a:hover { color: var(--gold); }
        
        .hero { padding: 100px 0; text-align: center; border-bottom: 1px solid #444; }
        .hero h1 { font-size: 3.5rem; margin-bottom: 20px; text-shadow: 0 0 20px rgba(245, 158, 11, 0.3); }
        
        .btn { background: linear-gradient(45deg, var(--bronze), var(--gold)); border: none; padding: 15px 40px; color: black; font-weight: 700; text-transform: uppercase; cursor: pointer; clip-path: polygon(10% 0, 100% 0, 100% 80%, 90% 100%, 0 100%, 0 20%); transition: 0.3s; }
        .btn:hover { filter: brightness(1.2); }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 40px; margin-top: 60px; }
        .card { background: var(--bg-card); padding: 40px; border: 1px solid var(--bronze-dark); position: relative; }
        .card::before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 2px; background: linear-gradient(90deg, transparent, var(--gold), transparent); }
        
        .product-img { width: 100%; height: 250px; object-fit: cover; filter: sepia(0.5); transition: 0.5s; }
        .card:hover .product-img { filter: sepia(0); }
        
        .footer { border-top: 1px solid var(--bronze); margin-top: 100px; padding: 60px 0; text-align: center; color: #78716c; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&display=swap" rel="stylesheet" />

            <div className="container">
                <nav className="nav">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="links">
                        <a href="#services">SERVICES</a>
                        <a href="#products">STORE</a>
                        <a href="#contact">CONTACT</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </nav>
                
                <header className="hero">
                    <h1>Timeless Quality</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '40px', color: '#a8a29e'}}>Forged in excellence. Built to last.</p>
                    <button className="btn">Discover More</button>
                </header>
                
                <h2 style={{textAlign: 'center', marginTop: '100px', fontSize: '2.5rem'}}>Our Offerings</h2>
                <div className="grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="card" key={index}>
                            <h3 style={{fontSize: '1.5rem', marginBottom: '15px'}}>{item.name}</h3>
                            <p style={{color: '#a8a29e', lineHeight: 1.6}}>{item.description}</p>
                            <div style={{display: 'flex', gap: '15px', marginTop: '20px'}}>
                                <a href={`tel:${get_data.mobile}`} style={{color: 'var(--gold)', letterSpacing: '1px', borderBottom: '1px solid var(--gold)', paddingBottom: '2px'}}>CALL</a>
                                <a href="#contact" style={{color: 'var(--text-main)', letterSpacing: '1px', borderBottom: '1px solid var(--text-main)', paddingBottom: '2px'}}>ENQUIRE</a>
                            </div>
                            <div style={{marginTop: '20px', width: '50px', height: '1px', background: 'var(--gold)'}}></div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>

                <h2 style={{textAlign: 'center', marginTop: '100px', fontSize: '2.5rem'}}>Artifacts</h2>
                <div className="grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{padding: 0}}>
                            {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                            <div style={{padding: '30px'}}>
                                <h3>{item.service_name}</h3>
                                {item.price && <div style={{color: 'var(--gold)', fontSize: '1.2rem', margin: '10px 0'}}>₹{item.price}</div>}
                                <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', marginTop: '10px', padding: '10px'}}>Purchase</button>
                            </div>
                        </div>
                     ))}
                </div>
                
                <footer className="footer" id="contact">
                    <h2 style={{color: '#57534e'}}>{get_data.service_name}</h2>
                    <p>{get_data.business_location_name}</p>
                </footer>
            </div>
        </>
    );
};

export default Twentythirdtheme;
